import React from 'react';
import { Button, Modal, Header } from 'semantic-ui-react';

class ModalDialog extends React.Component {

    render(){
        return(
            <Modal open={this.props.open}>
                {this.props.title?<Header style={{backgroundColor:"#2185d0", color:"#FFFFFF"}}>
                    {this.props.title}
                </Header>:null}
                
                <Modal.Content>
                    <Modal.Description>
                        {this.props.description}
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='blue' onClick={this.props.btnYesAction}>
                        {this.props.btnYesText}
                    </Button>
                    {this.props.btnNoText?<Button color='black' onClick={this.props.btnNoAction}>
                        {this.props.btnNoText}
                    </Button>:null}
                    
                </Modal.Actions>
            </Modal>
        )
    }

}

ModalDialog.defaultProps = {
    btnYesText : "Yes",
    btnYesAction : () => {},
    btnNoText : "",
    btnNoAction : () => {},
    description : "",
    title: "",
    open: true
}

export default ModalDialog;

